const optionsComponent = require('../optionsComponent/optionsComponent');

const toggle = Object.assign({}, optionsComponent, {
    okValue: '1',
    koValue: '0',
    subelements: {
        presence: false
    },

    init: function () {
        optionsComponent.init.call(this);

        if (this.parentAttribute !== null) {
            this.element.addEventListener('change', () => { this.filterDependables(); });
        }
    },

    getValue: function () {
        if (this.isHidden && this.hiddenValue !== false) {
            return this.hiddenValue;
        }

        if (this.element.checked) {
            return this.okValue;
        } else {
            return this.koValue;
        }
    },

    filterHide: function (attribute, value) {
        let action = optionsComponent.filterHide.call(this, attribute, value);

        if (action === 'show') {
            this.subelements.presence.value = 1;
        } else if (action === 'hide') {
            this.subelements.presence.value = 0;
        }

        return action;
    }
});

module.exports = toggle;